import * as types from '../../contactUs/constants/ActionTypes';

const initialState = {
  autoSuggestionFired: false,
  fullSearchFired: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.AUTO_SUGGESTION_FIRED: {
      return {
        ...state,
        autoSuggestionFired: true,
        fullSearchFired: false,
      };
    }
    case types.FULL_SEARCH_FIRED: {
      return {
        ...state,
        autoSuggestionFired: false,
        fullSearchFired: true,
      };
    }
    case types.CLEAR_QULATRICS_INTERCEPTS: {
      return {
        ...state,
        autoSuggestionFired: false,
        fullSearchFired: false,
      };
    }
    default:
      return state;
  }
}
